import React from "react";
import { EmendasParlamentaresPage } from "./emendasParlamentares.page";
import { EmendasParlamentaresProvider } from "./context/emendas-parlamentares-context";

export function EmendasParlamentaresFactory() {
    return (
        <EmendasParlamentaresProvider>
            <EmendasParlamentaresPage></EmendasParlamentaresPage>
        </EmendasParlamentaresProvider>
    );
}
